import { Component, OnInit,Input,ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/';
import { map } from 'rxjs/operators';
// import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { AlertService, EventCategoryService, AppService } from '../_services/index';
import $ from 'jquery/dist/jquery';
import {NgbModal, NgbActiveModal,NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';

class EventCategory {
  id: number;
  name: string;
  description: string;
  is_active: string;
}

@Component({
  selector: 'app-event-category',
  templateUrl: './event-category.component.html'
})
export class EventCategoryComponent implements OnInit {

  dtOptions: DataTables.Settings = {}; //  DataTable
    dtTrigger = new Subject(); //  DataTable
    eventCategoryList: EventCategory[] = []; // Table Data list
    isSubmitted = false;
    // countryAddForm: FormGroup;
    getEventCategory = {
      id:'',
      name: '',
      description: '',
      is_active: 'N'
    };
    modalReference:NgbActiveModal;
    modalTitle:string;
    constructor(
                public router: Router,
                private dataService:EventCategoryService,
                private alertService: AlertService,
                private AppService: AppService,
                private modalService: NgbModal
               ) { }
    eventcategory = {
      id:'',
      name: '',      
      description: '',
      is_active: 'Y'
    };
    showloding = true;
    lodingImage = false;

    ngOnInit() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.allEventCategory();
    }
  
    allEventCategory(){
      this.loadShow();
      this.dataService.getAllEventcategory()
          .pipe().subscribe(data => { 
            this.eventCategoryList = data['eventcategory']; 
            this.dtTrigger.next(); // Data Table
            this.loadHide();
          });
    }
  
    open(content) {
      this.isSubmitted = false;
      if (this.getEventCategory.id !=null) {
        this.getEventCategory.id='';
      }
      this.eventcategory.name = '',
      this.eventcategory.description = '',
      this.eventcategory.is_active = 'Y';
      this.modalTitle = "Add Event Category";
      this.modalReference = this.modalService.open(content);
    }
  
    edit(id,content){
      this.loadShow();
      this.dataService.getEventcategory(id)
          .pipe().subscribe(data => { 
                  this.getEventCategory = data['eventcategory']; 
                  this.eventcategory = {
                        id:this.getEventCategory.id,
                        name:this.getEventCategory.name,                        
                        description:this.getEventCategory.description,
                        is_active:this.getEventCategory.is_active
                  };
                  this.loadHide();
                  this.modalTitle = "Edit Event Category";
                  this.modalReference = this.modalService.open(content);
          });
    }
  
    save(val,f){
      this.isSubmitted = true;
      if(f.form.valid) {
        this.loadShow()
        if(val.id == ''){
          this.dataService.save(this.eventcategory)
              .pipe().subscribe(data =>{
                this.loadHide();
                this.modalReference.close();
                this.dtTrigger = new Subject(); //  DataTable
                this.alertService.success('Event category saved successfully', true);
                this.allEventCategory();
              },error =>{
                this.loadHide();
                this.alertService.error(error);
                document.querySelector(".modal").scrollTo({top:0,behavior:'smooth'});
              });
        }else{
          this.dataService.eventcategoryUpdate(this.eventcategory)
              .pipe().subscribe(data =>{
                this.loadHide();
                this.modalReference.close();
                this.dtTrigger = new Subject(); //  DataTable
                this.alertService.success('Event Category updated successfully', true);
                this.allEventCategory();
              },error =>{
                this.loadHide();
                this.alertService.error(error);
                document.querySelector(".modal").scrollTo({top:0,behavior:'smooth'});
              });
            }
          }
    }
  
    delete(id){
      if(confirm("Are you sure to delete")) {
        this.dataService.eventcategoryDelete(id)
            .pipe().subscribe(data =>{
              if(data['status']==200){
                this.dtTrigger = new Subject(); //  DataTable
                this.alertService.success('Event Category deleted successfully', true);
                this.allEventCategory();
              }else{
                this.alertService.error('Event Category error');
              }
            },error =>{
              this.alertService.error(error);
            });
          }
        }
  
    loadShow(){
      this.showloding = true;
      this.lodingImage = false;
    }
  
    loadHide(){
      this.showloding = false;
      this.lodingImage = true;
    }

}
